<template>
  <div class="last-page-container h-100 w-100" v-bind:style="backgroundStyle"  >
    <div class="" style="background:white;padding:2%;">
      <div class="row no-gutters" style="color:black;align-items:center;justify-content:center;">
        この作品が気に入ったらSNSへシェアしてね！
      </div>
      <div class="row no-gutters" style="color:black;align-items:center;justify-content:center;">
        <a :href="snsURL(shareTextT)" class="btn btn-social btn-twitter">
            <i class="fab fa-twitter"></i>ツイートする
        </a>
<!--        <a href="javascript:" @click="snsFBURL(shareTextT)" class="btn btn-social btn-facebook">
            <i class="fab fa-facebook-f"></i>シェアする
        </a>-->
      </div>
      
    </div>
    <div class="d-flex">
      <div class="flex-grow-1">
        <div class="work-area" >
          <div class="container-fluid pb-0 p-3" v-bind:style="backgroundStyle">
            <div class="row no-gutters" >
              <div class="col-4">
                <img class="img-fluid mb-2" v-bind:src="workThumbnailImage" />
              </div>
              <div class="col-8 pl-2">
                <p v-bind:style="textStyle">{{ catchPhrase }}</p>
                <p class="work-title" v-bind:style="textStyle">{{ workName }}</p>
                <p v-bind:style="textStyle">{{ authorName }}</p>
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </div>
    <div class="container-p1 pb-3" style="text-align:center;">
      <a href="https://go.onelink.me/taMo?pid=media&c=koreyomo">
        <img src="/koreyomo/static/assets/images/center.png" class="img-fluid" id="lastPageImage">
      </a>
    </div>

    <template v-if="nextStoryItem !== null">
      <div class="container-fluid p-0 mb-3" v-bind:style="borderStyle" style="width:95%;">
        <div class="row no-gutters align-items-center">
          <div class="col-3 p-2">
            <img class="img-fluid" v-bind:src="nextStoryItem.storyBannerImageUrl" />
          </div>
          <div class="col p-1">
            <p v-bind:style="textStyle">次の話へ</p>
            <p class="next-story-title" v-bind:style="textStyle">{{ nextStoryItem.storyTitle }}</p>
          </div>
          <div class="p-2">
            <template v-if="nextStoryItem.isWebRead">
              <router-link v-bind:style="buttonStyle" style="position: relative;z-index: 9999;" class="btn btn-read" :to="{ name: 'Viewer', params: { workCode: workCode, storyId: nextStoryId }, query: { rt: restoreToken, timeres: timeRes, pid: pid } }">
              試し読み
              </router-link>
            </template>
            <template v-else>
              <a style="position: relative;z-index: 9999;" v-bind:href="getMangahotDetailUrl(workCode, restoreToken, timeRes, pid)" v-bind:style="buttonStyle" class="btn btn-read">作品詳細へ戻る</a>
            </template>
          </div>
        </div>
      </div>
    </template>
    <div v-if="recommendItems.length > 0">
      <div class="w-100 px-3 py-1 recommend-label" v-bind:style="[textStyle, darkBackgroundStyle]">
        <p class="">この作品の読了感に近いオススメ作品はコチラ！</p>
      </div>
    </div>

    <div class="container-fluid">
      <div class="row" v-if="recommendItems.length > 0">
        <div class="p-0 col-6" v-for="item in recommendItems.slice(0, 4)">
          <a v-bind:href="getMangahotDetailUrl(item.workCode, restoreToken, personaId, timeRes)"><img v-bind:src="item.bannerMediumImageUrl" class="img-fluid"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import dynamicStyleMixin from "../components/DynamicStyleMixin";

  export default {
    name: "ViewerLastPageMobile",
    mixins: [dynamicStyleMixin],
    data () {
        return {
            personaId:'',
            shareTextT: 'Koreyomo',
            shareTextF: 'Koreyomo'
        }
    },
    props: {
      /** @type {?KoreyomoWorkInfo} */
      workInfo: {
        type: Object,
        default: () => null
      },
      /** @type {?KoreyomoStoryItem} */
      nextStoryItem: {
        type: Object,
        default: () => null
      },
      /** @type {Array.<KoreyomoWorkItem>}*/
      recommendItems: {
        type: Array,
        default: () => []
      },
      restoreToken: {
        type: String,
        default: () => undefined
      },
      timeRes: {
        type: String,
        default: () => undefined
      },
      pid: {
        type: String,
        default: () => undefined
      },
    },
    computed: {
      workCode: function() {
        return this.workInfo ? this.workInfo.workCode : ""
      },
      workName: function() {
        return this.workInfo ? this.workInfo.workName : ""
      },
      catchPhrase: function() {
        return this.workInfo ? this.workInfo.catchPhrase : ""
      },
      authorName: function() {
        return this.workInfo ? this.workInfo.authorName : ""
      },
      workThumbnailImage: function() {
        return this.workInfo ? this.workInfo.bannerLargeImageUrl : null
      },
      nextStoryId: function() {
        return this.nextStoryItem ? this.nextStoryItem.storyId : ""
      },
      // Override DynamicStyleMixin
      styleObject: function () {
        return this.workInfo
      },
    },
    mounted(){
      this.shareTextT = this.$parent.shareTextTwitter
      this.shareTextF = this.$parent.shareTextFB
      this.recommendWorksFromWorksData = this.$parent.recommendWorksFromWorksData
    }
  }
</script>

<style scoped>
  .last-page-container {
    overflow-y: auto;
  }

  .work-title {
    font-size: larger;
    font-weight: bold;
  }

  .next-story-title {
    font-weight: bold;
  }

  .recommend-label {
    font-weight: bold;
  }

  .btn-read {
    font-size: smaller;
    background-color: #ffffff;
    border-radius: 10px;
  }

  .btn-social{
    position:relative;
    /* padding-left:30px; */
    text-align:center;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    width:42%;
    max-width: 190px;
    margin:3%;
    
  }
  .btn-facebook{
      color:#fff;
      background-color:#3764A2;
      border-radius: 40px;
  }
  .btn-facebook:hover,.btn-facebook:focus,.btn-facebook:active,.btn-facebook.active,.open .dropdown-toggle.btn-facebook{color:#fff;background-color:#3764A2;}

  .btn-twitter{color:#fff;background-color:#5EA9DD;border-radius: 40px;}
  .btn-twitter:hover,.btn-twitter:focus,.btn-twitter:active,.btn-twitter.active,.open .dropdown-toggle.btn-twitter{color:#fff;background-color:#5EA9DD;}
  .result-of-recommendation-area .btn.focus, .result-of-recommendation-area .btn:focus{
        box-shadow: none;
  }

  @media screen and (max-width:320px) {
     .btn-social{
       font-size: 11px;
     }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/ViewerLastPageMobile.vue